import { render } from "./NotFound.vue?vue&type=template&id=46d9a507"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=46d9a507&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__